import { defaultTab } from '@/store/offers-dashboard/types';
import { NamedRoutes, QueryKeys } from '@/types';
import { hasPerm, isPartnerRole, P } from '@/utilities/roles/permissions';
import { TabIdStageMap, TabIdStageMapForAgent } from 'data';
import { UserRole } from '@/store/auth/types';
import { WorkflowAccessLevel } from 'types';

export function getPartnerAutoNavigationPath(
  userRole: UserRole,
  workflowAccess: string | undefined,
  canAccessApply: boolean,
  showWorkflowOptions: boolean,
): string | null {
  if (!isPartnerRole(userRole)) {
    return null;
  }

  const partnerFullAccess = workflowAccess === WorkflowAccessLevel.FullAccess;
  const partnerAdmissionAccess = workflowAccess === WorkflowAccessLevel.AdmissionsAccess;

  if (partnerAdmissionAccess && !partnerFullAccess) {
    return NamedRoutes.ADMISSIONS_WORKFLOW;
  }

  if (!partnerFullAccess && !partnerAdmissionAccess && !canAccessApply && !showWorkflowOptions) {
    return NamedRoutes.ROOT;
  }

  return null;
}

export function shouldShowItemConcise(userRole: UserRole, partnerFullAccess: boolean): boolean {
  return hasPerm(userRole, P.CHANGE_WORKFLOW) && !(isPartnerRole(userRole) && !partnerFullAccess);
}

export const buildAdmissionsParams = (isAgentOrPartnerUser: boolean) => {
  const params = new URLSearchParams();
  params.set(QueryKeys.PAGE, '1');
  params.delete(QueryKeys.STAGE);
  params.delete(QueryKeys.APPLICATION_STAGE);
  params.delete(QueryKeys.OFFER_STAGE);

  const currentTab = params.get(QueryKeys.CURRENT_TAB) ?? defaultTab;

  const statusMap: { offerStatuses: string[]; applicationStatuses: string[] } = isAgentOrPartnerUser
    ? TabIdStageMapForAgent[currentTab]
    : TabIdStageMap[currentTab];

  const { applicationStatuses, offerStatuses } = statusMap ?? {};

  for (const status of applicationStatuses ?? []) {
    params.append(QueryKeys.APPLICATION_STAGE, status);
  }

  for (const status of offerStatuses ?? []) {
    params.append(QueryKeys.OFFER_STAGE, status);
  }

  params.set(QueryKeys.CURRENT_TAB, currentTab);
  return params;
};
